
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/legal-hub",
      function () {
        return require("private-next-pages/clm/legal-hub/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/legal-hub"])
      });
    }
  